var map = {
	"./access-icon.svg": "./src/assets/access-icon.svg",
	"./avatar.png": "./src/assets/avatar.png",
	"./company-icon.svg": "./src/assets/company-icon.svg",
	"./employee-icon.svg": "./src/assets/employee-icon.svg",
	"./entity.png": "./src/assets/entity.png",
	"./fonts/nexa/Nexa_Bold.woff": "./src/assets/fonts/nexa/Nexa_Bold.woff",
	"./fonts/nexa/Nexa_Bold.woff2": "./src/assets/fonts/nexa/Nexa_Bold.woff2",
	"./fonts/nexa/Nexa_Light.woff": "./src/assets/fonts/nexa/Nexa_Light.woff",
	"./fonts/nexa/Nexa_Light.woff2": "./src/assets/fonts/nexa/Nexa_Light.woff2",
	"./fonts/nexa/stylesheet.css": "./src/assets/fonts/nexa/stylesheet.css",
	"./icon-mail-sent.png": "./src/assets/icon-mail-sent.png",
	"./icon-mail-sent.svg": "./src/assets/icon-mail-sent.svg",
	"./icon-security.svg": "./src/assets/icon-security.svg",
	"./icon-success.svg": "./src/assets/icon-success.svg",
	"./ima-logo-dark.svg": "./src/assets/ima-logo-dark.svg",
	"./ima-logo-light.svg": "./src/assets/ima-logo-light.svg",
	"./mailer/mail-computer.png": "./src/assets/mailer/mail-computer.png",
	"./mailer/mail-logo.png": "./src/assets/mailer/mail-logo.png",
	"./mailer/mail-password.png": "./src/assets/mailer/mail-password.png",
	"./my-data-icon.svg": "./src/assets/my-data-icon.svg",
	"./pending-licenses-icon.svg": "./src/assets/pending-licenses-icon.svg",
	"./person_cards/briefcase.svg": "./src/assets/person_cards/briefcase.svg",
	"./person_cards/business-card.svg": "./src/assets/person_cards/business-card.svg",
	"./person_cards/document.svg": "./src/assets/person_cards/document.svg",
	"./person_cards/file.svg": "./src/assets/person_cards/file.svg",
	"./registered-licenses-icon.svg": "./src/assets/registered-licenses-icon.svg",
	"./registered-mtr-icon.svg": "./src/assets/registered-mtr-icon.svg",
	"./registered-users-icon.svg": "./src/assets/registered-users-icon.svg",
	"./topbar-background.png": "./src/assets/topbar-background.png",
	"./transport-arrow.svg": "./src/assets/transport-arrow.svg",
	"./user.png": "./src/assets/user.png",
	"./waves-green-background.png": "./src/assets/waves-green-background.png",
	"./waves-grey-background.png": "./src/assets/waves-grey-background.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";